"use client";

import type { Locale } from "@/types/home";
import { useLocale } from "next-intl";
import ContactForm from "./ContactForm";
import ContactInfo from "./ContactInfo";
import ContactMap from "./ContactMap";

/** Contact page — form + office info. */
export default function ContactParent() {
  const ar = (useLocale() as Locale) === "ar";
  return (
    <div className="bg-white text-ash dark:bg-ash dark:text-white">
      <header className="mx-auto max-w-360 border-b border-black/10 px-6 pb-8 pt-24 lg:px-10 dark:border-white/10">
        <span className="text-[11px] uppercase tracking-widest text-accent">{ar ? "تواصل معنا" : "Get in touch"}</span>
        <h1 className="mt-2 font-bebas text-[clamp(2.5rem,6vw,5rem)] uppercase leading-none text-ash dark:text-white">
          {ar ? "لنبدأ مشروعك" : "Let's Build Your Legacy"}
        </h1>
        <p className="mt-3 max-w-xl text-ash/60 dark:text-white/60">
          {ar ? "تحدّث مع مستشار مخصّص. نردّ على كل استفسار خلال ساعتين." : "Speak with a dedicated advisor. We respond to every enquiry within two hours."}
        </p>
      </header>

      <section className="mx-auto grid max-w-360 gap-12 px-6 py-16 lg:grid-cols-2 lg:px-10">
        <ContactForm />
        <ContactInfo />
      </section>

      <ContactMap />
    </div>
  );
}
